import BuildingAHome from "../assets/files/landscape/building_a_home_for_a_tree.pdf";
import OakSystems from "../assets/files/landscape/oak_systems.pdf";
import PatchBurn from "../assets/files/landscape/patch_burn_graze.pdf";
import PrairieMatters from "../assets/files/landscape/prairie_matters.pdf";
import SpeciesComposition from "../assets/files/landscape/species_composition_of_old_settler.pdf";
import FireInMissouri from "../assets/files/landscape/fire_in_missouri.pdf";

interface EssayType {
  name: string;
  file: string;
}

export const LandscapeList: EssayType[] = [
  {
    name: "Building a Home for a Tree",
    file: BuildingAHome,
  },
  {
    name: "Oak Systems",
    file: OakSystems,
  },
  {
    name: "Patch Burn Graze",
    file: PatchBurn,
  },
  {
    name: "Prairie Matters",
    file: PrairieMatters,
  },
  {
    name: "Species Composition of Old Settler",
    file: SpeciesComposition,
  },
  {
    name: "The Role of Fire in Missouri",
    file: FireInMissouri,
  },
];

export default LandscapeList;
export type { EssayType };
